import React from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalFooter,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faFileSearch,
} from '@fortawesome/pro-solid-svg-icons';
import Dashboard from './Dashboard';

class RecordAdherenceModal extends React.PureComponent {
  showDash = () => {
    const { setPanel } = this.props;
    setPanel('dash');
  };

  showTotalTranscript = () => {
    const { setPanel } = this.props;
    setPanel('total');
  };

  render() {
    const {
      toggle,
      focusedId,
      record,
      panel,
    } = this.props;

    let title;
    if (panel === 'dash') {
      title = 'Script Adherence';
    } else if (panel === 'total') {
      title = 'Transcript Review';
    } else {
      title = `${record?.transcript_analysis?.sections?.[panel]?.section_name} Review`;
    }

    return (
      <Modal
        isOpen={focusedId === record.contact_id}
        toggle={toggle}
        size="lg"
        scrollable
        zIndex="100000"
      >
        <div className="modal-header d-flex align-items-center justify-content-between">
          <h5 className="text-capitalize m-0">
            {`${title}: Agent ${record.agent_first_name} ${record.agent_last_name}`}
          </h5>
          {panel === 'dash' ? (
            <Button
              size="sm"
              onClick={this.showTotalTranscript}
              disabled={!record?.transcript_analysis?.sections}
            >
              <FontAwesomeIcon
                fixedWidth
                icon={faFileSearch}
                className="me-1"
              />
              Review Transcript
            </Button>
          ) : (
            <Button size="sm" onClick={this.showDash}>
              <FontAwesomeIcon
                fixedWidth
                icon={faChevronLeft}
                className="me-1"
              />
              Back
            </Button>
          )}
        </div>

        {panel === 'dash' ? (
          <Dashboard analysis={record.transcript_analysis} />
        ) : null}

        <ModalFooter>
          <Button color="white" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  focusedId: state.records.scriptModalId,
  panel: state.diff.panel,
});

const mapDispatchToProps = {
  toggle: () => ({ type: 'TOGGLE_RECORD_SCRIPT' }),
  setPanel: (panel) => ({ type: 'SET_DIFF_PANEL', panel }),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordAdherenceModal);
